export const postsPerPage = 12
export const otherRole = 'Other (please specify)'
export const pledgeDownloadUrl =
  'https://ric-staging-uploads.s3.eu-west-2.amazonaws.com/RIC_resilience_action_plan_template_and_logos_374f0be73e.zip'
